(function ($) {
  DJ.addBehavior('tableSort', '.js-sortable-table', {
    attach: function () {
      const getCellValue = (tr, idx) => {
        const td = tr.children[idx];
        const tdSortable = td.dataset.sortableValue;
        return tdSortable !== undefined ? tdSortable : td.innerText || td.textContent;
      };
      const comparer = (idx, asc) => (a, b) => ((v1, v2) => (v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));
      const mq = window.matchMedia('(max-width: 767px)');
      const appendTableHeads = (query) => {
        if (query.matches) {
          $('td', $(this)).each((i, e) => {
            const table = $(e).closest('table');
            $(e).prepend(`<span class='th'>${$('th', table).eq($(e).index()).text()}</span>`);
          });
        }
      };

      appendTableHeads(mq);
      mq.addListener(appendTableHeads);

      document.querySelectorAll('th').forEach(th => th.addEventListener('click', (() => {
        const table = th.closest('table');
        Array.from(table.querySelectorAll('tr:nth-child(n+2)'))
          .sort(comparer(Array.from(th.parentNode.children).indexOf(th), this.asc = !this.asc))
          .forEach(tr => table.appendChild(tr));
      })));
    }
  });
})(jQuery);
